module.exports = __webpack_public_path__ + "09ff85ed1817b1e859a4d2e539032ce4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/sports/football.png
// module id = 1088
// module chunks = 0